<app-mens-intimate-wash>
  <p class="mb-4">
    Urinary Tract Infections (UTIs) can be stubborn, and if you've had sexual intercourse during your UTI episode,
    bacteria can transfer to your partner, increasing the risk of reinfection for both of you. This could lead to a
    frustrating cycle of recurring infections and prolonged discomfort. Our specially formulated
    <strong>Penile UTI Wash</strong> is designed to eliminate any residual bacteria and reduce the risk of reinfection.
  </p>
  <p class="mb-4">
    By using this wash daily for 5 days, you can
    <strong>help ensure that both you and your partner are clear of bacteria</strong>, supporting a smooth and complete
    recovery and reducing the chances of future UTIs.
  </p>
</app-mens-intimate-wash>
